import React from 'react';

import Button from '../../components/ButtonNew';
import {useAnalytics} from '../../hooks';
import {cx} from '../../util';
import {getBrandName} from '../../components/Brand';

const AddInterviewCard = ({tag, className}) => {
  const {tracker} = useAnalytics();

  return (
    <div className={cx('bg-gray-50 border border-gray-200 rounded-lg p-4 flex justify-between items-center flex-col sm:flex-row', className)}>
      <div className="flex items-center mb-3 sm:mb-0">
        {tag.image_url && (
          <img src={tag.image_url} alt={`${tag.name} logo`} className="h-8 w-8 mr-4 rounded-full object-contain" />
        )}
        <span className="text-sm text-gray-600 mr-5">
          {`Share your ${tag.name} interview experience and get answers from the ${getBrandName()} community.`}
        </span>
      </div>
      <Button
        href="/questions/contribute"
        onClick={() => tracker.hubClickContribute()}
        className="shrink-0 w-full sm:w-auto"
      >
        Add interview
      </Button>
    </div>
  );
};

export default AddInterviewCard;
